parasails.registerPage('homepage', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data(){
    return{
      scrollTimer:0,
      scrollY:0
    };
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },
  mounted: async function(){
    this._setHeroHeight();
  },
  created(){
    window.addEventListener('scroll',this.handleScroll);
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {

    clickHeroButton: async function() {
      // Scroll to the 'get started' section:
      $('html, body').animate({
        scrollTop: this.$find('[purpose="scroll-destination"]').offset().top
      }, 500);
    },

    // Private methods not tied to a particular DOM event are prefixed with _
    _setHeroHeight: function() {
      var $hero = this.$find('[purpose="full-page-hero"]');
      var headerHeight = $('[purpose="page-header"]').outerHeight();
      var heightToSet = $(window).height();
      heightToSet = Math.max(heightToSet, 500);//« ensure min height of 500px - header height
      heightToSet = Math.min(heightToSet, 1000);//« ensure max height of 1000px - header height
      $hero.css('min-height', heightToSet - headerHeight+'px');
    },

    // 下までスクロール
    scrollTop: function(){
      let elm = document.documentElement;

      // scrollHeight ページの高さ clientHeight ブラウザの高さ　(bottom=一番下までスクロールしたときのtopの値)
      let bottom = elm.scrollHeight - elm.clientHeight;

      // 垂直方向へ移動
      window.scroll(0, bottom);
    },

    showScrollTop: function() {
      // if(window.scrollY >= 560) {
      //   scrollHeader.value = true
      // } else {
      //   scrollHeader.value = false
      // }
    },

    scrollHandler(e) {
      this.showScrollTop = e.target.scrollTop > 300 ? false : true;
    },

    handleScroll:function(){
      if(this.scrollTimer){
        return;
      }
      this.scrollTimer = setTimeout(()=>{
        this.scrollY = window.scrollY;
        clearTimeout(this.scrollTimer);
        this.scrollTimer = 0;
      },100);
    },
    transition:function(){
      window.scrollTo({
        top:2000,//この行の数値を変える（2000にしています）
        behavior: 'smooth'
      });
    }

  }
});
